<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->
      <div
        v-show="$route.path != '/Machine/PaymentMachinePayment/save'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-barcode"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" @submit="formSubmit">
            <div class="row">
              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>Supplier:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'pmSupplier'"
                    :name="'pmSupplier'"
                    :select2-options="pmSupplierOptions"
                    v-model="pmSupplier"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4">
                <div class="form-group">
                  <label>Phase:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control'"
                    :id="'pmPhase'"
                    :name="'pmPhase'"
                    :select2-options="pmPhaseOptions"
                    v-model="pmPhase"
                    ref="pmPhaseSelect2"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4">
                <div class="form-group">
                  <label>Lot:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control'"
                    :id="'pmLot'"
                    :name="'pmLot'"
                    :select2-options="pmLotOptions"
                    v-model="pmLot"
                    ref="pmLotSelect2"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4">
                <div class="form-group">
                  <label>งวดที่ :</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control'"
                    :id="'pmTracheNo'"
                    :name="'pmTracheNo'"
                    :select2-options="pmTracheNoOptions"
                    v-model="pmTracheNo"
                    ref="pmTracheNoSelect2"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>เลขที่ PO:</label>
                  <input
                    v-model="pmPO"
                    type="text"
                    class="form-control"
                    placeholder="กรุณาระบุ เลขที่ PO"
                  />
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>เลขที่ Invoice:</label>
                  <input
                    v-model="pmInvoice"
                    type="text"
                    class="form-control"
                    placeholder="กรุณาระบุ เลขที่ Invoice"
                  />
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">ค้นหา</button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->
          <!--begin: Datatable -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable"
                id="machineTransactionTable"
              >
                <thead>
                  <tr>
                    <th class="all">วันที่รับวางบิล</th>
                    <th class="all">Supplier</th>
                    <th class="all">Phase</th>
                    <th class="all">Lot</th>
                    <th class="all">งวด</th>
                    <th class="all">ประเภทสินค้า</th>
                    <th class="all">ชื่อสินค้า</th>
                    <th class="all">แบรนด์สินค้า</th>
                    <th class="all">จำนวน</th>
                    <th class="all">ยอดเงินสุทธิ</th>
                    <th class="all">PO</th>
                    <th class="all">Invoice</th>
                    <th class="all">สถานะการวางบิล</th>
                    <th class="all text-center">
                      <input
                        type="checkbox"
                        id="selectAll"
                        @click="saveSummit('All')"
                      />
                      ชำระเสร็จสิ้น
                    </th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <!--end: Datatable -->
          <br />
          <form class="kt-form" ref="formSave" @submit="formSave">
            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">
                  บันทึกการชำระเงิน
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import router from "../../router";
import select2 from "../../Shared/Select2";
import DatatableWarning from "../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

let Action = Vue.extend({
  template: `
  <div>
    <input type="checkbox" id="data" @click="checkbox('data')"/>
  </div>`,
  methods: {
    checkbox: function(e) {
      let self = this;
      self.$parent.saveSummit(this.data.headerId);
    },
  },
});

export default {
  components: {
    select2,
  },
  data: function() {
    var self = this;
    return {
      pmPhase: null,
      pmLot: null,
      pmTracheNo: null,
      svOpenButton: false,
      pmSupplier: null,
      pmInvoice: null,
      pmPO: null,
      pmSaveSubmit: [],
      pmSubmitAll: false,
      pmPhaseOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterPhase/Select2Phase",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      pmLotOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MachinePayment/Select2Lot",
          data: function(params) {
            var query = {
              search: params.term,
              Phase: self.pmPhase,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      pmSupplierOptions: {
        placeholder: "กรุณาเลือกSupplier",
        allowClear: true,
        ajax: {
          delay: 300,
          url: "/Api/Vendors/Select2Vendor",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      pmTracheNoOptions: {
        placeholder: "กรุณาเลือกงวด",
        allowClear: true,
        ajax: {
          url: "/Api/MachinePayment/Select2Tranche",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              billStatus: true,
              paymentStatus: false,
              phase: self.pmPhase,
              lot: self.pmLot,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
    };
  },
  methods: {
    formReset: function(e) {
      var self = this;
      self.pmPhase = [];
      self.pmLot = [];
      self.pmTracheNo = null;
      self.pmSupplier = null;
      self.pmInvoice = null;
      self.pmPO = null;

      $("#pmPhase")
        .val("")
        .trigger("change");

      $("#pmLot")
        .val("")
        .trigger("change");

      $("#pmSupplier")
        .val("")
        .trigger("change");

      $("#pmTracheNo")
        .val("")
        .trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function(e) {
      e.preventDefault();
      var table = $("#machineTransactionTable").DataTable();
      table.draw();
    },
    formSave: function(e) {
      let self = this;
      let router = this.$router;
      e.preventDefault();
      if (!self.pmSubmitAll && self.pmSaveSubmit.length == 0) {
        Swal.fire("การเตือน", "กรุณาเลือกข้อมูล", "warning");
      } else {
        KTApp.blockPage({
          opacity: 0.05,
          message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
        });

        axios
          .post("/Api/MachinePayment/Save", {
            Phase: self.pmPhase,
            Lot: self.pmLot,
            Tranche: self.pmTracheNo,
            Supplier: self.pmSupplier,
            PO: self.pmPO,
            Invoice: self.pmInvoice,
            HeaderId: self.pmSaveSubmit,
            SubmitAll: self.pmSubmitAll,
          })
          .then(function(response) {
            if (response.data.status) {
              Swal.fire("สำเร็จ", response.data.message, "success").then(
                function() {
                  //router.go(), self.$parent.reloadDataTable(false);
                  self.formReset(e);
                }
              );
            } else {
              Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
            }
          })
          .catch(function(error) {
            Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
          })
          .then(function() {
            KTApp.unblockPage();
          });
      }
    },
    formSaveReset: function(e) {
      var self = this;
    },
    saveSummit: function(e) {
      var self = this;
      if (e == "All") {
        self.pmSubmitAll = !self.pmSubmitAll;
      } else {
        var check = self.pmSaveSubmit.includes(e);
        if (!check) {
          self.pmSaveSubmit.push(e);
        } else {
          self.pmSaveSubmit = self.pmSaveSubmit.filter((o) => o != e);
        }
      }
    },
  },
  async mounted() {
    $("#selectAll").click(function(e) {
      $(this)
        .closest("table")
        .find("td input:checkbox")
        .prop("checked", this.checked);
    });
    let self = this;
    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    var table = $("#machineTransactionTable");
    table
      .DataTable({
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/MachinePayment/SearchPayment",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            return JSON.stringify(
              $.extend(d, {
                Phase: self.pmPhase,
                Lot: self.pmLot,
                Tranche: self.pmTracheNo,
                Supplier: self.pmSupplier,
                PO: self.pmPO,
                Invoice: self.pmInvoice,
              })
            );
          },
          //  success:function(data) {
          //      var self = this
          //      if(data.data.length != 0)
          //      {
          //         self.svOpenButton = true;
          //      }
          // },
        },

        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
        <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [100, 500],

        pageLength: 100,

        language: {
          lengthMenu: "Display _MENU_",
        },

        // Order settings
        order: [[0, "desc"]],
        columns: [
          {
            data: "dateOfBilling",
            className: "text-center",
            width: "8%",
            render: function(data, type, full, meta) {
              return full.dateOfBillingString;
            },
          },
          {
            data: "vendorName",
            className: "text-center",
            orderable: false,
          },
          {
            data: "phase",
            className: "text-center",
            orderable: false,
          },
          {
            data: "lot",
            className: "text-center",
            orderable: false,
          },
          {
            data: "trancheNo",
            className: "text-center",
            orderable: false,
          },
          {
            data: "productTypeName",
            className: "text-center",
            orderable: false,
          },
          {
            data: "productName",
            className: "text-center",
            orderable: false,
          },
          {
            data: "productBrandName",
            className: "text-center",
            orderable: false,
          },
          {
            data: "amount",
            className: "text-center",
            orderable: false,
          },

          {
            data: "totalPrice",
            className: "text-center",
            orderable: false,
            render: function(data, type, full, meta) {
              if (data != null) {
                return data
                  .toFixed(0)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              } else {
                return "";
              }
            },
          },
          {
            data: "po",
            className: "text-center",
            orderable: false,
          },
          {
            data: "invoiceNo",
            className: "text-center",
            orderable: false,
          },
          {
            data: "billStatus",
            className: "text-center",
            orderable: false,
            render: function(data, type, full, meta) {
              if (data) {
                return '<i class="fas fa-check-circle text-success"></i>';
              } else {
                return '<i class="fas fa-times-circle text-danger"></i>';
              }
            },
          },
          {
            data: "headerId",
            className: "text-center",
            orderable: false,
            width: "10%",
            render: function(data, type, full, meta) {
              // return '<input type="checkbox" id="selectAll" @click="saveSummit("All")"/>';
              return '<div class="actions"></div>';
            },
          },
        ],
        rowCallback: function(row, data, index) {
          // $(row)
          // .find("td:eq(10)")
          // .css("background-color", "#F2DCDB");
          // $(row)
          // .find("td:eq(1)")
          // .css("background-color", "#F2DCDB");
        },
        drawCallback: function(settings) {
          if (settings.json.data.length === 0) {
            return false;
          }

          $.fn.dataTable.ext.errMode = 'none';
          var table = $("#machineTransactionTable");
          var rows = table.find($("tr"));

          var prevCheck = "";
          var mergeRow = 1;
          for (var r = 0; r <= rows.length; r++) {
            var dateOfBilling = $($(rows[r]).find("td")[0]).text();
            var phase = $($(rows[r]).find("td")[2]).text();
            var lot = $($(rows[r]).find("td")[3]).text();
            var trancheNo = $($(rows[r]).find("td")[4]).text();
            var check = `${dateOfBilling}#${phase}#${lot}#${trancheNo}`;
            if (prevCheck == "") {
              prevCheck = check;
              continue;
            }
            if (prevCheck == check) {
              mergeRow = mergeRow + 1;
              continue;
            }

            //hide col
            // col 1 merge ไม่ได้ เนื่องจากอาจจะมีต่าง supplier
            var cols = [0, 2, 3, 4, 9, 10, 11, 12, 13];
            for (var h = 1; h < mergeRow; h++) {
              for (var i = 0; i < cols.length; i++) {
                let c = cols[i];
                $($(rows[r - h]).find("td")[c]).hide();
              }
            }

            for (var i = 0; i < cols.length; i++) {
              let c = cols[i];
              $($(rows[r - mergeRow]).find("td")[c]).attr("rowspan", mergeRow);
            }
            //
            mergeRow = 1;
            prevCheck = check;
          }
          //   for (var i = 0; i < colsLength; i++) {
          //     if (cols.includes(i)) {
          //       var startIndex = 0;
          //       var lastIndex = 0;
          //       var startText = $($(rows[0]).find("td")[i]).text();
          //       //console.log("startText ", startText);
          //       for (var j = 1; j < rows.length; j++) {
          //         var cRow = $(rows[j]);
          //         var cCol = $(cRow.find("td")[i]);

          //         var currentText = cCol.text();
          //         //console.log("currentText ", currentText);

          //         if (currentText == startText) {
          //           removeLater.push(cCol);
          //           lastIndex = j;
          //           if (i == 12) {
          //             var cCol2 = $(cRow.find("td")[i + 1]);
          //             var cCol3 = $(cRow.find("td")[i + 2]);

          //             removeLater.push(cCol2);
          //             removeLater.push(cCol3);
          //           }

          //           if (i == 5) {
          //             var cCol4 = $(cRow.find("td")[i + 5]);
          //             removeLater.push(cCol4);
          //           }
          //         } else {
          //           var spanLength = lastIndex - startIndex;
          //           if (spanLength >= 1) {
          //             $($(rows[startIndex]).find("td")[i]).attr(
          //               "rowspan",
          //               spanLength + 1
          //             );
          //           }

          //           if (i == 12) {
          //             $($(rows[startIndex]).find("td")[i + 1]).attr(
          //               "rowspan",
          //               spanLength + 1
          //             );
          //             $($(rows[startIndex]).find("td")[i + 2]).attr(
          //               "rowspan",
          //               spanLength + 1
          //             );
          //           }
          //           if (i == 5) {
          //             $($(rows[startIndex]).find("td")[i + 5]).attr(
          //               "rowspan",
          //               spanLength + 1
          //             );
          //           }

          //           lastIndex = j;
          //           startIndex = j;
          //           startText = currentText;
          //         }
          //       }

          //       var spanLength = lastIndex - startIndex;
          //       if (spanLength >= 1) {
          //         $($(rows[startIndex]).find("td")[i]).attr(
          //           "rowspan",
          //           spanLength + 1
          //         );

          //         if (i == 12) {
          //           $($(rows[startIndex]).find("td")[i + 1]).attr(
          //             "rowspan",
          //             spanLength + 1
          //           );
          //           $($(rows[startIndex]).find("td")[i + 2]).attr(
          //             "rowspan",
          //             spanLength + 1
          //           );
          //         }

          //         if (i == 5) {
          //           $($(rows[startIndex]).find("td")[i + 5]).attr(
          //             "rowspan",
          //             spanLength + 1
          //           );
          //         }
          //       }
          //     }
          //   }

          //   for (var i in removeLater) {
          //     $(removeLater[i]).hide();
          //   }
        },
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      })
      .on("draw.dt", function() {
        $(".actions").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          //console.log(data);
          if (data) {
            data.showDetailButton = self.$root.canShow();
            new Action({ data: { data }, parent: self }).$mount(el);
          }
        });
      });
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Machine/PaymentMachinePayment.vue